/** @format */
export type objAbstract = { [key: string]: unknown };

function isObjectEmpty(obj: object): boolean {
  return Object.keys(obj).length === 0;
}

function hasNestedObject(obj: object): boolean {
  let hasNested = false;
  // eslint-disable-next-line
  for (const [_, val] of Object.entries(obj)) {
    if (typeof val === "object") {
      hasNested = true;
      break;
    }
  }
  return hasNested;
}

/**
 * only works as intended when neither object contains any nested objects
 */
function singleLevelObjEQ(obj1: objAbstract, obj2: objAbstract): boolean {
  // NOTE: could ensure that both objs don't contain nested objs, but would introduce extra computation (hasNestedObject).
  //       Just use the function in cases where you have already checked for no nesting.
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function getObjectDiff(
  oldObject: objAbstract,
  newObject: objAbstract,
): object {
  let objDiff = {};
  for (const [newKey, newValue] of Object.entries(newObject)) {
    if (oldObject[newKey] === newValue) continue;

    if (newValue === undefined || newValue === null) {
      objDiff = { ...objDiff, [newKey]: newValue };
      continue;
    }

    if (
      typeof oldObject[newKey] === "undefined" ||
      (typeof newValue !== "object" && oldObject[newKey] !== newValue)
    ) {
      objDiff = { ...objDiff, [newKey]: newValue };
      continue;
    }

    if (typeof newValue === "object") {
      if (
        (!hasNestedObject(newValue) &&
          !singleLevelObjEQ(
            oldObject[newKey] as objAbstract,
            newValue as objAbstract,
          )) ||
        (newValue.constructor.name === "Array" &&
          !singleLevelObjEQ(
            oldObject[newKey] as objAbstract,
            newValue as objAbstract,
          ))
      ) {
        objDiff = { ...objDiff, [newKey]: newValue };
      } else {
        const nextLvl = getObjectDiff(
          oldObject[newKey] as objAbstract,
          newValue as objAbstract,
        );
        if (!isObjectEmpty(nextLvl)) {
          objDiff = {
            ...objDiff,
            [newKey]: nextLvl,
          };
        }
      }

      continue;
    }
  }

  return objDiff;
}

export const exportForTestingDONTIMPORT = {
  isObjectEmpty,
  hasNestedObject,
  singleLevelObjEQ,
};
